import React from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import type { SetOptional } from 'type-fest'
import type { UseDocumentResult } from '@ztechapps/common.hook'
import type { Task } from '@ztechapps/common.contract'
import { taskTooltipQueries } from './graphql'
import { useTaskTooltipPopOverContext } from './Context'

type TaskTooltipPopOverInlineInputProps = SetOptional<InlineInputProps, 'mutationConfig' | 'initialValues'> & {
  taskDocument: UseDocumentResult<Task>
}

export const TaskTooltipPopOverInlineInput = ({
  taskDocument,
  parentInputComponent,
  name,
  ...rest
}: TaskTooltipPopOverInlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput
  const { canEdit } = useTaskTooltipPopOverContext()
  const task = taskDocument?.document
  const initialValues = task

  return <ParentInput {...{ initialValues, canEdit, mutationConfig: taskTooltipQueries.updateConfig, name, ...rest }} />
}
